import React from 'react';
import { Box, Heading, Text } from '@chakra-ui/react';
import { SIGN_IN_BLURB, SIGN_IN_TITLE } from '../../constants/guestExperienceCopy';

interface SignInHeaderProps {
  isMobile?: boolean;
  /** Replaces the default welcome heading while a gated action explains why. */
  title?: string | null;
}

export const SignInHeader: React.FC<SignInHeaderProps> = ({ isMobile, title }) => (
  <Box w="full" textAlign="center" mb={isMobile ? 0 : 4}>
    <Box display="flex" justifyContent="center" mb={isMobile ? 3 : 3}>
      <img
        src="/icon-512x512.png"
        alt=""
        width={isMobile ? 56 : 72}
        height={isMobile ? 56 : 72}
        style={{ borderRadius: isMobile ? '14px' : '18px' }}
      />
    </Box>
    <Heading
      as="h1"
      fontSize={isMobile ? 'xl' : '2xl'}
      fontWeight="bold"
      fontFamily="heading"
      letterSpacing="tight"
      lineHeight="short"
      mb={1.5}
    >
      {title || SIGN_IN_TITLE}
    </Heading>
    <Text
      color="textMuted"
      fontSize="sm"
      maxW={isMobile ? '18rem' : 'none'}
      mx="auto"
      textWrap="pretty"
    >
      {SIGN_IN_BLURB}
    </Text>
  </Box>
);
